export default __webpack_public_path__ + "static/Stone_Stairway_Hardscapes_Andreatta_Waterscapes_Grants_Pass_Oregon-d360eb5d26740c4db2561807535835d0.jpg";